import ResizeDetector from './ResizeDetector';
import withResizeDetector from './withResizeDetector';
import useResizeDetector from './useResizeDetector';
export { withResizeDetector, useResizeDetector };
export default ResizeDetector;
